<template>
  <v-card height="100%">
    <v-card-title primary-title>
      <div class="headline">Insureds</div>
      <v-spacer></v-spacer>
      <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <template v-if="insureds.length > 0">
      <v-data-table :headers="headers" :items="insureds" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.nricPassport }}</td>
          <td class="text-xs-right">{{ formatDate(props.item.dob) }}</td>
          <td class="text-xs-right">{{ gender(props.item.gender) }} </td>
          <td class="text-xs-right">{{ props.item.isStudent? 'Yes' : 'No' }}</td>
          <td class="text-xs-right" v-if="renderRelationship">{{ relationship(props.item.relationship) }}</td>
        </template>
      </v-data-table>
    </template>
    <template v-else>
      <v-card-text>
        No Data Available
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { gender } from '@/const/underwriting'
import { relationship } from '@/const/underwriting/travel'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      headers: [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'NRIC/Passport No.', align: 'right', value: 'nricPassport' },
        { text: 'Date of Birth', align: 'right', value: 'dob' },
        { text: 'Gender', align: 'right', value: 'gender' },
        { text: 'Student', align: 'right', value: 'isStudent' }
      ],
      search: undefined
    }
  },
  computed: {
    insureds() {
      return this.$store.state.agency.quotation.travelForm.insureds
    },
    renderRelationship() {
      if (this.$store.state.agency.quotation.travelForm.travelType === 'F') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    gender(val) {
      if (val) {
        return gender[val]
      } else {
        return ''
      }
    },
    relationship(val) {
      if (val) {
        return relationship[val]
      } else {
        return '-'
      }
    }
  },
  created() {
    if (this.renderRelationship) {
      this.headers.push({ text: 'Relationship', align: 'right', value: 'relationship' })
    }
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style>
</style>
